export default __webpack_public_path__ + "static/media/sub-category-eventsAndVenues-sportsVenue.1445b2a4.jpg";